module.exports = __webpack_public_path__ + "img/hz_15.267ab942.jpg";